export interface ContentUploadGq {
  id: number;
  projectId: number;
  csvRows?: number;
  csvBatches?: number;
  uploadStartTime: string;
  rerunStartTime?: string;
  addToExistingEndTime?: string;
  addToExistingFailTime?: string;
  csvParsingStartTime?: string;
  csvParsingEndTime?: string;
  csvParsingFailTime?: string;
  addCreateKeywordsEndTime?: string;
  duplicateCheckEndTime?: string;
  complete: boolean;
}

export const ContentUploadGqProps = `
  id
  projectId
  csvRows
  csvBatches
  uploadStartTime
  rerunStartTime
  addToExistingEndTime
  addToExistingFailTime
  csvParsingStartTime
  csvParsingEndTime
  csvParsingFailTime
  addCreateKeywordsEndTime
  duplicateCheckEndTime
  complete
`;
